import { BaseCrudService } from "@/services/base";
import { Floor } from "@/swagger/models";
import { eventbus } from "@/eventbus";

class FloorService extends BaseCrudService<Floor> {
    constructor() {
        super({
            apiPrefix: "floors",
            entityName: "floor",
        });
    }

    async uploadFloorplan(floorId: number, file: File): Promise<Floor> {
        try {
            const formData = new FormData();
            formData.append("file", file);

            const res = await this.axios.post<Floor>(`${floorId}/floorplan`, formData, {});
            eventbus.$emit(`${this.config.entityName}:update`, res.data);
            this.tosti.success({ message: "Floorplan uploaded" });
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not upload floorplan: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }

    build(fields: Partial<Floor> & Pick<Floor, "officeId">): Floor {
        return Object.assign(
            {
                name: "New floor",
                level: 0,
            },
            fields,
        );
    }
}

export const floorService = new FloorService();
